import { render, staticRenderFns } from "./returnProfitDetail.vue?vue&type=template&id=5b631fbe&scoped=true&"
import script from "./returnProfitDetail.vue?vue&type=script&lang=js&"
export * from "./returnProfitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b631fbe",
  null
  
)

export default component.exports